(function() {
    function initFaqAccordion() {
        // ONLY select the Gutenberg block wrappers to avoid conflicts with PHP injected FAQs
        const faqContainers = document.querySelectorAll('.wp-block-remote-x-blocks-faq-accordion');

        faqContainers.forEach(container => {
            container.removeEventListener('click', handleAccordionClick);
            container.addEventListener('click', handleAccordionClick);
        });
    }

    function handleAccordionClick(event) {
        const button = event.target.closest('.accordion-trigger') || event.target.closest('.accordion-question button');
        
        if (button) {
            event.preventDefault(); 
            
            const questionWrapper = button.closest('.accordion-question');
            if (!questionWrapper) return;

            const answerPanel = questionWrapper.querySelector('.accordion-answer-panel');
            const icon = button.querySelector('.d-arrow');

            if (answerPanel) {
                const isExpanded = answerPanel.classList.toggle('show');
                button.setAttribute('aria-expanded', isExpanded);
                
                if (icon) {
                    icon.classList.toggle('rotate');
                }
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFaqAccordion);
    } else {
        initFaqAccordion();
    }
})();